import type { RawAgreementResponse } from '@heviton/heviton-api-v2';
import type { Agreement } from '@/shared/data-types';

/**
 * BE `RawAgreementResponse` → FE `Agreement`. **순수 변환** — 검증·throw 없음.
 * optional/null 은 빈 값으로 graceful 격하 (ADR `domain-ssot` §5).
 */
export function fromRawAgreement(raw: RawAgreementResponse): Agreement {
  return {
    agreementId: raw.agreement?.id ?? '',
    agreementName: raw.agreement?.name ?? '',
    agreementContentMarkdown: raw.agreement?.content ?? '',
  };
}
